import React, { Dispatch, SetStateAction, useContext, useState } from 'react'
import Dialog from '../../dialog/Dialog'
import { objectGetKeys, objectGetValues } from '../../../utils/ieCompatibility'
import { chargementIcone, ChargementTexteChamp, gestionChampsFormulaire } from '../utils/gestionChampsFormulaire'
import { WHITE } from '../../../theme'
import styles from '../../../styles'
import Button from '../../button/Button'
import { FormattedMessage } from 'react-intl'
import SvgSearch from '../../../icons/SvgSearch'
import Link from '../../link/Link'
import { FormApi, ValidationErrors } from 'final-form'
import { makeStyles } from 'tss-react/mui'
import { champsMenuRechercheEnum } from '../../../modules/resultats-recherche/enums/champsMenuRecherche'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material'
import { FormulaireRechercheModel, INITIAL_FORMULAIRE_RECHERCHE } from '../../../modules/resultats-recherche/types/formulaireRechercheModel'
import { Close, ExpandMore } from '@mui/icons-material'
import { RechercheContext } from '../../../modules/resultats-recherche/utils/RechercheContext'

const useStyles = makeStyles()(
	(theme) => ({
		popinContainer: {
			background: '#eff3f5',
			padding: '30px 30px 150px 30px !important'
		},
		closeIcon: {
			width: 45,
			height: 45,
			borderRadius: 45,
			background: theme.palette.blue.main,
			cursor: 'pointer',
			marginBottom: 23,
			padding: 9,
			boxSizing: 'border-box',
			color: WHITE
		},
		accordeonContainer: {
			background: WHITE,
			boxShadow: '0px 0px 15px #12294133',
			borderRadius: '39px !important',
			marginBottom: 21,
			maxHeight: 423,
			overflow: 'auto',

			'&::-webkit-scrollbar': {
				width: 16
			},
			'&::-webkit-scrollbar-thumb': {
				background: 'transparent',
				borderRadius: 30,
				boxShadow: 'inset 0 0 10px 10px #D0D5DA',
				border: 'solid 4px transparent'
			}
		},
		champTexte: {
			minHeight: 75,
			paddingLeft: 31,
			paddingRight: 45,

			'& > div:first-child': {
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				width: '80%',

				'& span': {
					marginLeft: 19,
					...styles(theme).text2,
					textOverflow: 'ellipsis',
					overflow: 'hidden'
				}
			}
		},
		detailAccordeon: {
			paddingLeft: 31,
			paddingRight: 32
		},
		footer: {
			position: 'fixed',
			bottom: 0,
			left: 0,
			zIndex: 1,
			padding: '20px 45px 20px 31px',
			background: '#eff3f5'
		},
		flouHaut: {
			position: 'absolute',
			top: -48,
			left: 0,
			height: 50,
			width: '100%',
			background: 'linear-gradient(180deg, rgba(239,243,245,0), rgb(239,243,245))'
		},
		boutonSubmit: {
			width: 185,
			height: 75,
			borderRadius: 42,
			marginLeft: 'auto',
			justifyContent: 'space-around'
		},
		errors: {
			border: '1px solid #B92D00',
			'& .champ-label': {
				color: '#B92D00 !important'
			}
		},
		overflowPopinRecherche: {
			overflow: 'hidden'
		}
	})
)

interface AcceptingProps {
	popinRecherche: boolean
	onCloseDialog: () => void
	formValues: FormulaireRechercheModel
	formulaireTouche: boolean
	setFormulaireTouche: Dispatch<SetStateAction<boolean>>
	form: FormApi<FormulaireRechercheModel>
	errors: ValidationErrors
}

type PopinMenuRechercheProps = AcceptingProps

const PopinMenuRecherche: React.FC<PopinMenuRechercheProps> = (
	{
		popinRecherche,
		onCloseDialog,
		formValues,
		formulaireTouche,
		setFormulaireTouche,
		form,
		errors
	}
) => {
	const { classes, cx } = useStyles()
	const [voirPlusPrestation, setVoirPlusPrestation] = useState(false)
	const [voirPlusParking, setVoirPlusParking] = useState(false)
	const [expanded, setExpanded] = useState('')
	const { setFiltres } = useContext(RechercheContext)

	const handleChange = (id: string) => {
		expanded === id ? setExpanded('') : setExpanded(id)
	}

	return (
		<Dialog
			onCloseDialog={onCloseDialog}
			open={popinRecherche}
			dialogStyle={classes.popinContainer}
			className={
				cx(
					{
						[classes.overflowPopinRecherche]: popinRecherche
					}
				)
			}
		>
			<>
				<Close
					className={classes.closeIcon}
					onClick={(e) => {
						e.stopPropagation()
						onCloseDialog()
					}}
				/>

				{
					objectGetValues(champsMenuRechercheEnum).map(
						(champMenuRecherche) => (
							<Accordion
								key={champMenuRecherche}
								expanded={expanded === champMenuRecherche}
								onChange={() => handleChange(champMenuRecherche)}
								className={
									cx(
										classes.accordeonContainer,
										{
											[classes.errors]: !!errors && champMenuRecherche in errors && formulaireTouche
										}
									)
								}
							>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls={champMenuRecherche}
									id={`${champMenuRecherche}-header`}
									className={classes.champTexte}
								>
									{chargementIcone(champMenuRecherche)}

									{ChargementTexteChamp(formValues, champMenuRecherche)}
								</AccordionSummary>

								<AccordionDetails className={classes.detailAccordeon}>
									{gestionChampsFormulaire(champMenuRecherche, voirPlusPrestation, setVoirPlusPrestation, formValues, voirPlusParking, setVoirPlusParking)}
								</AccordionDetails>
							</Accordion>
						)
					)
				}

				<Grid
					container
					item
					xs={12}
					className={classes.footer}
				>
					<div className={classes.flouHaut}></div>
					<Grid container item xs={6}>
						<Link
							color="colorBlue"
							prevent
							onClick={() => {
								form.reset(INITIAL_FORMULAIRE_RECHERCHE)
								setFiltres(INITIAL_FORMULAIRE_RECHERCHE)
							}}
							hasChevron={false}
							noAnimation
							textStyle="text8"
							style={{
								textDecoration: 'underline'
							}}
						>
							<FormattedMessage
								id="resultatsRecherche.menu.toutEffacer"
								defaultMessage="Tout effacer"
								description="'bouton' pour vider le form"
							/>
						</Link>
					</Grid>

					<Grid container item xs={6}>
						<Button
							background="backgroundAccessibility"
							color="colorWhite"
							textStyle="text8"
							type="submit"
							onClick={() => {
								setFormulaireTouche(true)

								if (objectGetKeys(errors).length === 0) {
									onCloseDialog()
									form.submit()
								}
							}}
							buttonStyle={classes.boutonSubmit}
						>
							<SvgSearch color={WHITE} />

							<FormattedMessage
								id="resultatsRecherche.menu.rechercher"
								defaultMessage="Rechercher"
								description="Bouton rechercher"
							/>
						</Button>
					</Grid>
				</Grid>
			</>
		</Dialog>
	)
}

export default PopinMenuRecherche